// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tox-tinymce-aux{z-index:5000!important}.tinymce-container img{max-width:100%}", ""]);
// Exports
module.exports = exports;
